import { useEffect, useRef, useState } from "react";

const Counter = ({ end, suffix = "+", duration = 1200 }) => {
  const [value, setValue] = useState(0);
  const counterRef = useRef(null);

  useEffect(() => {
    const node = counterRef.current;
    let frameId;

    const animate = () => {
      const start = performance.now();

      const tick = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        setValue(Math.round(eased * end));

        if (progress < 1) {
          frameId = requestAnimationFrame(tick);
        }
      };

      frameId = requestAnimationFrame(tick);
    };

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          animate();
          observer.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      observer.disconnect();
      cancelAnimationFrame(frameId);
    };
  }, [duration, end]);

  return (
    <strong ref={counterRef}>
      {value}
      {suffix}
    </strong>
  );
};

export default Counter;
